import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  width: 100%;
`;

export const FormContainer = styled.form<{
  isEmpty: boolean;
  searchInit: boolean;
}>`
  align-items: center;
  background: ${({ theme }) => theme.colors.white};

  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  width: 100%;
  cursor: pointer;
`;

export const BlackBorder = styled.div<{ searchInit: boolean }>`
  border: ${({ searchInit }) => searchInit && "1px solid black"};
  border-radius: 5px;
  width: 100%;
`;

export const InputContainer = styled.div<{
  isEmpty: boolean;
  searchInit: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-width: ${({ searchInit }) => (searchInit ? "4px" : "1px")};
  border-style: solid;
  border-color: ${({ theme, searchInit }) =>
    searchInit ? theme.colors.orange : theme.colors.grey100};
  padding: 0 10px;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    border: 4px solid ${({ theme }) => theme.colors.orange};
  }

  input {
    align-items: center;
    border: none;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 21px 10px;
    flex: 1;
    box-shadow: none;
    color: ${({ theme }) => theme.colors.grey600};
    font-family: Aileron;
    font-size: 16px;
    font-weight: 600;
    outline: 0;
    transition: all 0.3s ease;
  }

  input:placeholder-shown {
    text-overflow: ellipsis;
  }

  input::placeholder {
    color: ${({ theme }) => theme.colors.grey400};
    font-family: Aileron;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
  }
`;

export const Button = styled.button<{ isDisabled: boolean }>`
  align-items: center;
  background: ${({ theme, isDisabled }) =>
    isDisabled ? theme.colors.grey200 : theme.colors.blue};
  border: 0;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  display: flex;
  gap: 12px;
  justify-content: center;
  font-family: Aileron;
  font-size: 16px;
  font-weight: 700;
  padding: 20px 47px;
  transition: all 0.3s ease;

  &:hover {
    border: ${({ theme, isDisabled }) =>
      !isDisabled && `4px solid ${theme.colors.orange}`};
    text-decoration: ${({ isDisabled }) => !isDisabled && "underline"};
  }

  ${media.lessThan("medium")`
    padding: 20px 47px;
  `}

  ${media.lessThan("small")`
    padding:22px;
  `}

  p {
    ${media.lessThan("small")`
       display:none;
    `}
  }
`;

export const ResetSearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
  gap: 9px;

  ${media.lessThan("small")`
    padding-right:10px;
    width:100%;
  `};
`;

export const TextContainer = styled.div`
  ${media.lessThan("small")`
    display:none;
  `}
`;
